import React from "react";
import styled from "styled-components";
import { Select, Space } from "antd";
import PropTypes from "prop-types";
import { MixStyle } from "../styles";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const { Option } = Select;

const StyledSelect = styled(Select)`
  width: ${({ width }) => width};
  .select__placeholder {
    ${MixStyle.flexCenter};
    svg {
      margin-right: 5px;
    }
  }
  svg {
    font-size: ${(props) => (props.type === "filter" ? "unset" : "16px")};
    color: ${(props) =>
      props.type === "filter" ? "rgba(0, 0, 0, 0.25)" : "#404e67"};
  }
  .ant-select-arrow {
    width: ${(props) => (props.type === "filter" ? "unset" : "25px")};
    top: ${(props) => (props.type === "filter" ? "50%" : "40%")};
  }
  .ant-select-selector {
    background: #ffffff;
    border: 1px solid #d5d5d5;
    box-sizing: border-box;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
    border-radius: ${({ radius }) => radius} !important;

    height: ${({ height }) => height} !important;
  }
  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    display: flex;
    align-items: center;

    ${MixStyle.inputTextSize}
    opacity:unset;
  }
  .ant-select-selection-search-input {
    height: 100% !important;
  }
`;
const SelectCompo = ({
  children,
  prefixIcon,
  placeholder,
  onChange,
  defaultValue,
  Options,
  type,
  NewClothQualityOption,
  ...rest
}) => {
  return (
    <StyledSelect
      {...rest}
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder={
        <span className="select__placeholder">
          {prefixIcon ? prefixIcon : ""}
          {placeholder}
        </span>
      }
    >
      {type === "dispatches"
        ? Options.map(({ dispatch_id, date_dispatch, k_qunatity }) => (
            <Option key={dispatch_id} value={dispatch_id}>
              <Space>
                <span className="themed--color_pink">k.Quanity:</span>
                {k_qunatity}
                <span className="themed--color_pink">Dispatch Date :</span>
                {CHANGE_DATE_FORMAT.changeDateFormat(date_dispatch)}
              </Space>
            </Option>
          ))
        : type === "qualities"
        ? Options.map(
            ({ cloth_quality_id, pick, reed, type, warp, weft, width }) => (
              <Option key={cloth_quality_id} value={cloth_quality_id}>
                {reed +
                  "*" +
                  pick +
                  "/" +
                  warp +
                  "*" +
                  weft +
                  "=" +
                  width +
                  "″" +
                  type}
              </Option>
            )
          )
        : type === "yarnQualities"
        ? Options.map(({ id, count, con_size, brand, type }) => (
            <Option key={id} value={id}>
              {count + "/" + con_size + "/" + brand + "/" + type}
            </Option>
          ))
        : type === "sizeryarnQualities"
        ? Options.map(({ id, count, con_size, brand, type }) => (
            <Option key={id} value={brand}>
              {count + "/" + con_size + "/" + brand + "/" + type}
            </Option>
          ))
        : type === "sizerList"
        ? Options.map(({ sizer_id, sizer_name }) => (
            <Option key={sizer_id} value={sizer_id}>
              {sizer_name}
            </Option>
          ))
        : type === "taxes"
        ? Options.map(({ tax_rate_id, tax_name, tax_rate }) => (
            <Option key={tax_rate_id} value={tax_rate}>
              <Space>
                {/* <span className="themed--color_pink">Tax Name : </span> */}
                {tax_name}
                <span className="themed--color_pink">/</span>
                {tax_rate}
              </Space>
            </Option>
          ))
        : type === "selvedge"
        ? Options.map(({ selvedge_input }) => (
            <Option key={selvedge_input} value={selvedge_input}>
              <Space>
                {/* <span className="themed--color_pink">Tax Name : </span> */}
                {selvedge_input}
              </Space>
            </Option>
          ))
        : type === "weave"
        ? Options.map(({ weave_input }) => (
            <Option key={weave_input} value={weave_input}>
              <Space>
                {/* <span className="themed--color_pink">Tax Name : </span> */}
                {weave_input}
              </Space>
            </Option>
          ))
        : type === "hsCode"
        ? Options.map(({ hs_code_id, hs_code }) => (
            <Option key={hs_code_id} value={hs_code}>
              <Space>
                {/* <span className="themed--color_pink">Tax Name : </span> */}
                {hs_code}
              </Space>
            </Option>
          ))
        : Options.map((value, index) => (
            <Option key={index} value={value}>
              {value}
            </Option>
          ))}
    </StyledSelect>
  );
};
SelectCompo.propTypes = {
  height: PropTypes.string,
  radius: PropTypes.string,
  width: PropTypes.string,
};
SelectCompo.defaultProps = {
  height: "50px",
  radius: "10px",
};

export default SelectCompo;
